// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_SyncSubaccountResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payments/anticipations/sync_subaccount/{id}
 *
 * Returns the batch sync result from AnticipationSyncService::syncSubaccount().
 * The shape is the fixed `$results` accumulator built in that method:
 * total/synced/failed/unchanged counts plus a list of error message strings.
 *
 * @see AnticipationSyncService::syncSubaccount()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsAnticipations_SyncSubaccountResponseDados {
total: number
synced: number
failed: number
unchanged: number
errors: string[]
}

export type SubaccountsAnticipations_SyncSubaccountResponse = ApiResponse<SubaccountsAnticipations_SyncSubaccountResponseDados>;

registerResponseContract('SubaccountsAnticipations_SyncSubaccountResponse', {
  total:     { type: 'number',  required: true },
  synced:    { type: 'number',  required: true },
  failed:    { type: 'number',  required: true },
  unchanged: { type: 'number',  required: true },
  errors:    { type: 'array',   required: true },
})
